import React, { useRef, useState } from 'react';
import { uploadAPI } from '../../api';
import { Upload, ImageOff } from 'lucide-react';
import toast from 'react-hot-toast';

export default function ImageUpload({ value, onChange, size = 96 }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    setUploading(true);
    try {
      const res = await uploadAPI.upload(file);
      onChange(res.data.url);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to upload image');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
      <div style={{
        width: size, height: size, borderRadius: 12, background: '#f1f5f9',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        overflow: 'hidden', flexShrink: 0, border: '1px solid #e2e8f0',
      }}>
        {value ? (
          <img src={value} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <ImageOff size={24} color="#cbd5e1" />
        )}
      </div>
      <div>
        <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} style={{ display: 'none' }} />
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 16px', background: '#ede9fe', border: 'none', borderRadius: 8, color: '#7c3aed', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}
        >
          <Upload size={14} /> {uploading ? 'Uploading...' : value ? 'Replace Image' : 'Upload Image'}
        </button>
        <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 6 }}>JPG, PNG, or WebP. Max 5MB.</div>
      </div>
    </div>
  );
}
